import { Api } from '../api';
import { recipients } from '../endpoints';
import type { ApiPaginate, ApiResponse } from '../../models';
import type {
  RecipientCreateRequest,
  RecipientGetListRequest,
  RecipientGetMandatoryFieldsRequest,
  RecipientGetRecentRequest,
  RecipientResponse,
  RecipientUpdateRequest,
} from './models';

export class RecipientsApi extends Api {
  static getRecipients = (request: RecipientGetListRequest, signal?: AbortSignal) =>
    this.get<ApiPaginate<RecipientResponse[]>>({ url: recipients.getRecipients(), queryParams: request, signal });

  static getRecipient = (request: string, signal?: AbortSignal) =>
    this.get<ApiResponse<RecipientResponse>>({ url: recipients.getRecipient(), queryParams: { id: request }, signal });

  static getRecentRecipients = (request: RecipientGetRecentRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<RecipientResponse[]>>({ url: recipients.getRecentRecipients(), queryParams: request, signal });

  static getMandatoryFields = (request: RecipientGetMandatoryFieldsRequest, signal?: AbortSignal) =>
    this.get<ApiResponse<string[]>>({ url: recipients.getMandatoryFields(), queryParams: request, signal });

  static createRecipient = (request: RecipientCreateRequest, signal?: AbortSignal) =>
    this.post<RecipientCreateRequest, ApiResponse<RecipientResponse>>({ url: recipients.createRecipient(), data: request, signal });

  static updateRecipient = (request: RecipientUpdateRequest, signal?: AbortSignal) =>
    this.put<RecipientUpdateRequest, RecipientResponse>({ url: recipients.updateRecipient(), data: request, signal });

  static deleteRecipient = (id: string) =>
    this.delete<{ Id: string }, ApiResponse<RecipientResponse>>({ url: recipients.deleteRecipient(id), queryParams: { Id: id }, data: { Id: id } });
}
